import Link, { LinkProps as LinkPropsMui } from '@mui/material/Link';
import { Link as LinkDom, LinkProps } from 'react-router-dom';

interface Props extends LinkPropsMui {
  to?: LinkProps['to'];
  listRole?: string[][];
}

const LinkPM = (props: Props) => {
  const { to, children, listRole, ...rest } = props;

  if (to) {
    return (
      <Link variant="inherit" underline="none" {...rest} to={to} component={LinkDom}>
        {children}
      </Link>
    );
  }
  return (
    <Link variant="inherit" underline="none" {...rest}>
      {children}
    </Link>
  );
};
export default LinkPM;
